// CrmView.js — centro de control de clientes que contactan (CRM), unificando
// piezas que antes vivían separadas y con accesos distintos:
//   - "Bandeja" (IncidenciasTab.js) vivía dentro de Órdenes de trabajo,
//     visible solo para admin/coordinador — atención al cliente no podía ver
//     el estado de las incidencias que ella misma creaba. Se sigue usando el
//     mismo componente (y se sigue viendo también dentro de Órdenes de
//     trabajo, por si a operaciones le sirve verla en ese contexto) — no se
//     duplica lógica, solo se le da un segundo punto de entrada.
//   - "Clientes" (ClientesView.js) era solo para admin.
//   - El formulario de alta (IncidenceFormView.js) era la ÚNICA pieza
//     accesible para atención al cliente — de ahí que fuera "crear y ya
//     está", sin poder consultar nada después.
//
// Mismo patrón de pestañas que Órdenes de trabajo/Mantenimientos: una sola
// entrada de menú, pestañas dentro. `initialTab` decide con cuál se abre —
// preserva los flujos existentes que ya navegan aquí con una expectativa
// concreta (ver App.js): 'incidence' (CRM Email → "Nueva orden", y el
// aterrizaje por defecto de atención al cliente) espera abrir directo en
// "Nuevo contacto"; 'v2-clientes' (SearchModal → zapata_open_cliente) espera
// abrir directo en "Clientes" con la ficha ya cargada.
//
// IncidenceFormView es una pantalla de página completa por diseño (min-h-
// screen, barra inferior fija) — no se le fuerza una altura de contenedor
// como al resto de pestañas (que sí la necesitan para su scroll interno de
// tabla), se deja fluir en el documento tal cual lo hacía cuando era la
// única vista de 'incidence'.
import React, { useState } from 'react';
import IncidenciasTab from './v2/IncidenciasTab';
import IncidenceFormView from './IncidenceFormView';
import ClientesView from './v2/ClientesView';
import CrmAnaliticaTab from './CrmAnaliticaTab';

const TABS = [
  { id: 'bandeja',   label: 'Bandeja' },
  { id: 'nuevo',     label: 'Nuevo contacto' },
  { id: 'clientes',  label: 'Clientes' },
  { id: 'analitica', label: 'Analítica' },
];

export default function CrmView({ onNavigate, initialTab = 'bandeja' }) {
  const [tab, setTab] = useState(initialTab);

  const cabecera = (
    <>
      <div className="flex items-center justify-between gap-3 flex-wrap flex-shrink-0 px-4 sm:px-0 pt-4 sm:pt-0">
        <h1 className="text-xl font-bold text-gray-900">CRM</h1>
      </div>
      <div className="flex items-center bg-gray-100 rounded-xl p-1 gap-1 w-fit flex-shrink-0 flex-wrap mx-4 sm:mx-0 mt-3">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all ${tab === t.id ? 'bg-white text-red-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}>
            {t.label}
          </button>
        ))}
      </div>
    </>
  );

  if (tab === 'nuevo') {
    return (
      <div>
        {cabecera}
        <div className="mt-3">
          <IncidenceFormView onNavigate={onNavigate} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-[calc(100vh-100px)] gap-3">
      {cabecera}
      <div className="flex-1 min-h-0">
        {tab === 'bandeja' ? (
          <IncidenciasTab onNavigate={onNavigate} />
        ) : tab === 'clientes' ? (
          <ClientesView />
        ) : (
          <CrmAnaliticaTab />
        )}
      </div>
    </div>
  );
}
